import type { NightguardFormParams } from '@witmetrics/unison-core';
import type { NightguardParameterKey } from '@witmetrics/utils';
import { NIGHTGUARD_PARAMETERS } from '@witmetrics/utils/constants';
import ServiceParameter from '@/components/ServiceParameter';
import TabsBlock, { Tab } from '@/components/TabsBlock';
import EngravementForm from '../EngravementForm';
import type { NightguardFormSection } from './types';
import { classes } from '../utils';

export type NightguardsFormProps = {
  params: NightguardFormParams;
  onChange: (params: NightguardFormParams) => void;
};

export default function NightguardsForm({
  params,
  onChange,
}: NightguardsFormProps) {
  const renderParam = (key: NightguardParameterKey) => (
    <ServiceParameter
      parameter={NIGHTGUARD_PARAMETERS[key]}
      value={params[key]}
      onChange={(update) => onChange({ ...params, ...update })}
    />
  );

  return (
    <TabsBlock<NightguardFormSection[]>
      className={classes.tabsBlock}
      bodyClassName={classes.tabsBody}
      orientation="vertical"
      name="nightguard-parameters"
      defaultTab="BITE">
      <Tab className={classes.tab} name="BITE" label="Bite">
        {renderParam('posteriorBiteOpening')}
        {renderParam('anteriorBiteOpening')}
        {renderParam('minimumThickness')}
      </Tab>
      <Tab className={classes.tab} name="SPLINT" label="Splint">
        {renderParam('splintType')}
        {renderParam('lingualCuspsSupport')}
        {renderParam('buccalThickness')}
        {renderParam('impressionDepth')}
      </Tab>
      <Tab className={classes.tab} name="GUIDANCE" label="Guidance">
        {renderParam('sagittalCondylarAngleProtrusion')}
        {renderParam('sagittalCondylarAngleRetrusion')}
        {renderParam('sagittalLateralCondylarAngle')}
        {renderParam('protrusionGuidance')}
        {renderParam('retrusionRange')}
        {renderParam('laterotrusionRange')}
      </Tab>
      <Tab className={classes.tab} name="OUTLINE" label="Outline">
        {/* TODO: Outlines */}
        {renderParam('retention')}
        {renderParam('offset')}
      </Tab>
      <Tab className={classes.tab} name="WAXING" label="Waxing">
        {renderParam('edentulousZones')}
        {renderParam('lingualWire')}
        {renderParam('interproximalWaxing')}
        {renderParam('gumLineWaxing')}
      </Tab>
      <Tab className={classes.tab} name="PREPROCESSING" label="Pre-processing">
        {renderParam('biteCorrection')}
        {params.biteCorrection !== 'no_correction' &&
          renderParam('maxBitePenetration')}
        {renderParam('attachmentRemoval')}
        {renderParam('impressionCleaning')}
        {params.impressionCleaning !== 'no_impression_cleaning' &&
          renderParam('artifactThreshold')}
      </Tab>
      <Tab className={classes.tab} name="ADVANCED" label="Advanced">
        <EngravementForm
          engravedText={params.engravedText}
          onChange={(engravedText) => onChange({ ...params, engravedText })}
        />
        {renderParam('excludeLastHalfMolarFromOutline')}
        {renderParam('baseInfill')}
        {renderParam('baseHeight')}
      </Tab>
    </TabsBlock>
  );
}
